import { render, staticRenderFns } from "./reviewdoctor.vue?vue&type=template&id=6a535f83&scoped=true&"
import script from "./reviewdoctor.vue?vue&type=script&lang=js&"
export * from "./reviewdoctor.vue?vue&type=script&lang=js&"
import style0 from "./reviewdoctor.vue?vue&type=style&index=0&id=6a535f83&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a535f83",
  null
  
)

export default component.exports